import { GenIcon } from '../helpers/IconBase.es.js';

const PbSliderTwoRowFilled = (props) => {
  return GenIcon({
    tag: "svg",
    attr: { viewBox: "0 0 46 32", fill: "none" },
    child: [
      {
        tag: "rect",
        attr: {
          x: "8.3335",
          y: "8",
          width: "29.3333",
          height: "7",
          rx: "1",
          fill: "#8E8E8E"
        }
      },
      {
        tag: "rect",
        attr: {
          x: "8.3335",
          y: "17",
          width: "29.3333",
          height: "7",
          rx: "1",
          fill: "#8E8E8E"
        }
      }
    ]
  })(props);
};

export { PbSliderTwoRowFilled };
